module.exports = __webpack_public_path__ + "static/media/whatsapp_background.11f6bb8f.png";